(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive(
            'fbFieldSelect', fbFieldSelect);

    function fbFieldSelect($timeout, lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: "=",
                eventHandler: '&'
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldSelect',
            controller: fbFieldSelectCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem) {
                var vm = scope.vm;
                $timeout(function () {
                    var trigger_change = lodash.get(vm.element, 'options.trigger_change_on_load', false);
                    if (trigger_change) {
                        vm.onEventTrigger('onChange');
                    }
                    if (lodash.get(vm.element.options.selectize, 'emptyOptionLabel') || lodash.get(vm.element.options.selectize, 'emptyModelLabel')) {
                        elem.find('.selectize-input').css('padding-top', '5px');
                    }
                    // elem.find('.selectize-input input').attr('readonly','readonly');;
                });
            }
        };
    }

    function fbFieldSelectCtrl(lodash, FormBuilderService, $scope, GenericModel, ActionCommon, $timeout, FbSelectService,RequestHelper) {
        // $scope.$watch(function() { return vm.model; }, function() { console.log('fieldSelect model', vm.model); });
        var vm = this;
        var formIdentifier = '';
        this.$onInit = function() {
            if (vm.model === undefined && lodash.has(vm.element, 'options.default')) {
                lodash.set(vm, 'model', vm.element.options.default);
            }
            vm.selectize = null;
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            //vm.getEventDetails = getEventDetails;
            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            vm.element.refreshData = loadRemoteData;

            // preparing additionalOptionss
            vm.eventsCreateOptions = vm.pageData.eventsService.getEventOptions(vm.element.elementIdentifier, 'onCreate');
            vm.additionalOptions = {};

            FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

            if (!lodash.isEmpty(vm.eventsCreateOptions)) {
                // only allow create if eventsCreateOptions is not empty
                vm.additionalOptions.create = createFunc;
            }

            if (lodash.has(vm.element, 'options.datasource.data')) {
                vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                $scope.$watch(function () {
                    return vm.element.options.datasource.data;
                }, function () {
                    if (vm.firstLoad) {
                        $timeout(function () {
                            vm.firstLoad = false;
                        });
                    } else {
                        $timeout(function () {
                            vm.isLoading = true;
                            vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                            emptyOptionLabel();
                            var hasDefaultModel = angular.copy(lodash.get(vm.element, 'options.selectize.hasDefaultModel', true));
                            if(!hasDefaultModel){
                                vm.model = undefined;
                                vm.selectize.items = [""];
                            }
                            $timeout(function () {
                                vm.isLoading = false;
                            }, 800);
                        });
                    }

                });
            }

            if (lodash.has(vm.element, 'options.datasource.optgroup_data')) {
                vm.additionalOptions.optgroups = vm.element.options.datasource.optgroup_data;
            }

            vm.firstLoad = true;
            vm.selectizeMsg = '';

            vm.config =
                angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        maxItems: 1,
                        searchField: ['label'],
                        plugins: ['remove_button'],
                        // dropdownParent: 'body',
                        // dropdownClass: 'selectize-dropdown modal-z-index',
                        // placeholder: '',
                        onChange: function () {
                            vm.onEventTrigger('onChange');
                        },
                        onBlur: function () {
                            vm.onEventTrigger('onBlur');
                        },
                        onInitialize: function (selectize) {
                            vm.selectize = selectize;
                            loadRemoteData();
                            $timeout(function () {
                                emptyOptionLabel();
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    vm.selectize.disable();
                                }
                            });
                        }
                    },
                    lodash.get(vm.element, 'options.selectize', {}),
                    vm.additionalOptions
                );
        };

        function createFunc(value, callback) {

            var formModel = FormBuilderService.getModel(formIdentifier);
            var modelData = {
                data: {label: value, model: formModel}
            };

            var model = new GenericModel(vm.eventsCreateOptions.datasource.url);
            var method = lodash.get(vm.eventsCreateOptions.datasource, 'method', 'post');
            model[method]({}, modelData, function (res) {
                // alert('succes');
                ActionCommon.show_floating_notifier(vm.eventsCreateOptions.successNotifier);
                vm.pageData.eventsService.refreshDataOfElement(vm.element.name);
                // callback, provided by selectize, will add the new option into the select.
                callback(res.item);
            }, handleRequestError);
        }

        function handleRequestError() {
            // alert('failed');
            ActionCommon.show_floating_notifier(vm.eventsCreateOptions.errorNotifier);
        }

        function loadRemoteData() {
            if (lodash.has(vm.element, 'options.datasource.url')) {
                vm.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function (res) {
                    vm.isLoading = false;
                    var msg = lodash.get(res, 'error_msg');

                    if (msg || res.length === 0) {
                        vm.selectizeMsg = msg;
                        if (lodash.has(vm.element,'options.selectize.emptyOptionLabel')) {
                        //     // res.push({"value":0, "label":lodash.get(vm.element,'options.selectize.emptyOptionLabel')});                            
                            var placeholder = lodash.get(vm.element,'options.selectize.emptyOptionLabel');
                            vm.selectize.settings.placeholder = placeholder;
                            vm.selectize.updatePlaceholder();
                        }
                        return vm.selectize.disable();
                    }
                    vm.ds = res;
                });
            }
        }

        function callRemoteApi() {
            var model = new GenericModel(vm.element.options.datasource.url);
            var method = lodash.get(vm.element.options.datasource, 'method', 'get');
            var model_keys = lodash.get(vm.element.options.datasource, 'model_keys',null);
            var model_data = FormBuilderService.getModel(formIdentifier);

            if (model_keys != undefined ){
                model_data = RequestHelper.getNeeded(model_data, model_keys);
            }
            return model[method]({}, {data: model_data}).$promise.then(function (res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function (res) {
                console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }

        function emptyOptionLabel() {
            if (lodash.has(vm.element,'options.selectize.emptyOptionLabel')) {
                if (!lodash.has(vm.element, 'options.datasource.url')) {        
                    if (vm.ds.length === 0) {
                        vm.selectize.settings.placeholder = lodash.get(vm.element,'options.selectize.emptyOptionLabel');
                        vm.selectize.updatePlaceholder();
                        vm.selectize.disable();
                    }else{           
                        vm.selectize.settings.placeholder = lodash.get(vm.element,'options.selectize.emptyModelLabel');
                        vm.selectize.updatePlaceholder();
                        vm.selectize.enable();
                    }
                }
            }
        }
    }
})();